import { CoreExecutorResult } from "../../core/index.js";
import { DataPsmExecutorResultFactory } from "./data-psm-executor-utils.js";
import { DataPsmClass, DataPsmSchema } from "../model/index.js";
export async function executeDataPsmSetJsonLdTypeMapping(reader, createNewIdentifier, operation) {
    const resource = await reader.readResource(operation.dataPsmEntity);
    if (resource == null || (!DataPsmSchema.is(resource) && !DataPsmClass.is(resource))) {
        return DataPsmExecutorResultFactory.invalidType(resource, "data-psm schema or class");
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...resource,
            jsonLdDefinedTypeMapping: operation.jsonLdDefinedTypeMapping,
        },
    ]);
}
//# sourceMappingURL=data-psm-set-json-ld-type-mapping-executor.js.map